var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import UploadedCvIcon from './icons/IconUploadedCv';
var FileUploader = function (_a) {
    var files = _a.files, setFiles = _a.setFiles, fileError = _a.fileError, setFileError = _a.setFileError, fileName = _a.fileName;
    var fileInputRef = useRef(null);
    var onDrop = function (acceptedFiles) {
        var _a;
        var newFileOb = {};
        newFileOb[fileName] = acceptedFiles[0];
        setFiles(__assign(__assign({}, files), newFileOb));
        if (acceptedFiles.length > 0) {
            setFileError(__assign(__assign({}, fileError), (_a = {}, _a[fileName] = '', _a)));
        }
    };
    var _b = useDropzone({
        onDrop: onDrop,
        accept: {
            'application/pdf': ['.pdf'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        },
        maxSize: 15 * 1024 * 1024,
        multiple: false,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    var handleFileSelect = function (event) {
        var _a;
        if (event.target.files) {
            var selectedFiles = Array.from(event.target.files);
            var newFileOb = {};
            newFileOb[fileName] = selectedFiles[0];
            setFiles(__assign(__assign({}, files), newFileOb));
            setFileError(__assign(__assign({}, fileError), (_a = {}, _a[fileName] = '', _a)));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({}, getRootProps(), { className: "vas-w-full vas-max-w-lg vas-mx-auto vas-border-2 vas-border-dashed vas-rounded-lg vas-p-6 vas-text-center vas-transition ".concat(isDragActive ? 'vas-bordervas-primary vas-bgvas-primary/10' : 'vas-border-gray-300'), children: [_jsx("input", __assign({}, getInputProps())), _jsx("div", { className: 'vas-w-24 vas-mx-auto vas-mb-4', children: _jsx(UploadedCvIcon, {}) }), _jsx("h2", { className: 'vas-text-lg vas-font-semibold vas-text-gray-800', children: "Drag & Drop" }), _jsx("p", { className: 'vas-text-[#8E95AA]', children: "Your files here Or Browse to upload" }), _jsx("p", { className: 'vas-text-[#26BBF1] vas-text-sm', children: "Only DOCX, PDF files with max size of 15 MB." }), files[fileName] && (_jsx("ul", { className: 'vas-mt-4 vas-text-sm vas-text-gray-700', children: _jsx("li", { children: files[fileName].name }) }))] })), fileError[fileName] && _jsx("p", { className: 'vas-text-red-500 vas-text-sm', children: fileError[fileName] }), _jsx("input", { type: 'file', ref: fileInputRef, onChange: handleFileSelect, accept: '.pdf,.docx', className: 'vas-hidden' })] }));
};
export default FileUploader;
